import { render, staticRenderFns } from "./PinsCards.vue?vue&type=template&id=6c3360d0&scoped=true"
import script from "./PinsCards.vue?vue&type=script&lang=ts"
export * from "./PinsCards.vue?vue&type=script&lang=ts"
import style0 from "./PinsCards.vue?vue&type=style&index=0&id=6c3360d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3360d0",
  null
  
)

export default component.exports